import { object } from 'yup'
import { ObjectShape } from 'yup/lib/object'

export const getValidationSchema = (schema: ObjectShape) =>
  object().shape(schema)
